<template>
  <div class="fill-height" v-if="error">
    <GenericError />
  </div>

  <v-row class="fill-height" align="center" justify="center" v-else-if="isLoading">
    <v-progress-circular indeterminate size="50" color="primary"></v-progress-circular>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import GenericError from 'usail-vue-sdk/components/error/GenericError'

export default {
  name: 'AuthCallback',
  components: {
    GenericError
  },
  data() {
    return {
      keycloakUser: null,
      userInfoError: false,
      user: null
    }
  },

  computed: {
    ...mapFields('user', {
      isLoading: 'isLoading',
      allIds: 'allIds',
      userError: 'error'
    }),
    ...mapGetters('user', ['find']),

    error() {
      return this.userError || this.userInfoError
    }
  },

  created() {
    let self = this
    this.$keycloak
      .loadUserInfo()
      .then(user => {
        this.keycloakUser = user
        this.keycloakUser.token = this.$keycloak.token
        this.$usailSecurity.setUser(this.keycloakUser)
        try {
          this.retrieve('/users/' + user.sub + '/with-roles')
        } catch (e) {
          console.log(e)
        }
      })
      .catch(function() {
        self.userInfoError = true
      })
  },

  watch: {
    allIds(ids) {
      this.user = this.find(ids[0])
      this.keycloakUser = Object.assign(this.user, this.keycloakUser)
      this.$usailSecurity.setUser(this.keycloakUser)
      this.$emit('setUserInfo', this.keycloakUser)

      if (localStorage.getItem('callbackUrl')) {
        const callbackUrl = localStorage.getItem('callbackUrl')
        localStorage.removeItem('callbackUrl')
        this.$router.replace(callbackUrl)
      } else {
        this.$router.replace('/')
      }
    }
  },

  methods: {
    ...mapActions('user', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    })
  }
}
</script>
